<template functional>
    <router-link v-if="props.to" class="btn-icon" :to="props.to" v-on:click="listeners.click && listeners.click()">
        <i class="badge-circle " :class="[data.staticClass, data.class, {
            'bx bx-trash badge-circle-danger': props.type === 'delete',
            'bx badge-circle-light-secondary bx-edit-alt': props.type === 'edit',
            'loading': props.loading
        }]"></i>
    </router-link>
    <a v-else href="#" class="btn-icon" v-on:click="listeners.click && listeners.click()">
        <i class="badge-circle " :class="[data.staticClass, data.class, {
            'bx bx-trash badge-circle-danger': props.type === 'delete',
            'bx badge-circle-light-secondary bx-edit-alt': props.type === 'edit',
            'loading': props.loading
        }]"></i>
    </a>
</template>

<script>
export default {
    name: 'BtnIcon',
};
</script>
